import React from "react"

import { homeColor, homeText } from "../home-theme.ts"
import { IconTile } from "./home-icons.tsx"

interface HomeSectionHeaderProps {
  title: string
  /** The quiet line that follows the title on the same baseline. */
  caption?: React.ReactNode
  /** A small tinted glyph before the title, as Cash Flow and Project Status have. */
  icon?: React.FC<React.SVGProps<SVGSVGElement>>
  /**
   * Sits immediately after the title group, not at the far edge — View All and
   * Show more belong to the section they open, however wide the card gets.
   */
  action?: React.ReactNode
  /** Widget chrome (refresh / expand / export), which does sit at the edge. */
  extra?: React.ReactNode
  padding?: string
  bordered?: boolean
}

export const HomeSectionHeader = ({
  title,
  caption,
  icon,
  action,
  extra,
  padding = "14px 20px",
  bordered = true
}: HomeSectionHeaderProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding,
      borderBottom: bordered ? `1px solid ${homeColor.border}` : undefined
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        minWidth: 0,
        flexWrap: "wrap"
      }}
    >
      {icon ? (
        <IconTile
          icon={icon}
          size={26}
          iconSize={16}
          radius={7}
          background={homeColor.tealPale}
          color={homeColor.teal}
        />
      ) : null}
      <h2 style={{ ...homeText.sectionTitle, color: homeColor.ink, margin: 0 }}>
        {title}
      </h2>
      {caption ? (
        <span style={{ ...homeText.label, color: homeColor.inkMuted }}>{caption}</span>
      ) : null}
      {action}
    </div>
    {extra ? <div style={{ marginLeft: "auto" }}>{extra}</div> : null}
  </div>
)
